














































































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { SelectedChannel, ChannelGroup } from '@/core/components/networkViewer/types';
import { Formatters } from '@/core/components/networkViewer/formatters';
import { ContextsState } from '@/store';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import { LogisticsNetwork } from '@/dto/';
import { CONTRACTS, FetchServiceContract } from '@/core/contracts';
import Icon from '@/core/components/controls/Icon.vue';
import { guid } from '@/core/helpers/utils';
@Component({
    components: {
        Icon
    }
})
export default class ChannelControls extends Vue {
    // TODO showPointChannels
    // TODO updateChannelName
    // TODO openChannelSettings
    // TODO deleteChannel
    // TODO selectChannel

    @Prop({ type: Object, required: true }) public network!: LogisticsNetwork;
    @Prop({ type: Object, required: true }) public settings!: any;
    @Prop({ type: Object, required: true }) public model!: any;
    @Prop({ type: Object, required: false }) public selectedChannel!: SelectedChannel;

    @Inject(CONTRACTS.FetchService)
    private _fetchService?: FetchServiceContract;

    private id: string = '';

    private get cssLeft() {
        let result = Formatters.prototype.svg_selected_channel_achor(
            this.selectedChannel,
            4,
            this.network.preferences.channel.maxDisplayCapacityWidth
        );
        result = Formatters.prototype.get(result, 'x');
        result = Formatters.prototype.add(
            result,
            this.network.state.offset.x ?? 0
        );

        return result;
    }

    private get cssTop() {
        let result = Formatters.prototype.svg_selected_channel_achor(
            this.selectedChannel,
            4,
            this.network.preferences.channel.maxDisplayCapacityWidth
        );
        result = Formatters.prototype.get(result, 'y');
        result = Formatters.prototype.add(
            result,
            this.network.state.offset.y ?? 0
        );
        result = Formatters.prototype.sub(result, 24);

        return result;
    }

    private date(value: any) {
        return Formatters.prototype.date(value, null, null);
    }

    private getId() {
        this.id = guid();
    }

    // show point channels from ui
    private async showPointChannels(representation: any) {
        if (!representation.nameEditable) {
            if (this.selectedChannel.point.count <= 1) {
                return;
            }

            this.selectedChannel.expanded = !this.selectedChannel.expanded;

            if (!this.selectedChannel.expanded) {
                this.selectedChannel.point.data = null;
            } else {
                const data = await this.getChannels(this.selectedChannel.point.groupId);

                if (this.selectedChannel.expanded) {
                    this.selectedChannel.point.data = null;
                    this.selectedChannel.point.data = data;
                    this.getId();
                }
            }
        }
    }

    private async getChannels(groupId: any) {
        const contextId = ContextsState.currentContextId;
        const url = `/contexts/${contextId}/map/viewport/${groupId}/channels`;
        const data = await this._fetchService!.get<ChannelGroup[]>(url);

        return data;
    }

    // enable edit name from ui for rv-editable binder
    private enableEditName(object: any) {
        object.nameEditable = true;
    }
}
